import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MatrixGrid.html?raw';
import on from 'dojo/on';
import SelectBox from '../SelectBox/SelectBox';
import "../SelectBox/SelectBox";
import "../Button/Button";

import { ColorHelpers, DOMhelpers, StringHelpers, ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";

import EntityStore from '../../Tools/EntityStore';
class MatrixGrid<X = any, Y = any, Z = any> extends compose(_WidgetBaseSP) {
	templateString: any = template;

	private entityStore: MdsLax<InstanceType<typeof EntityStore<Matrix.CellData<Z>>>>;
	private _changeStateDisplayNode: HTMLElement;

	private inputSelectionValue: MdsLax<InstanceType<typeof SelectBox>>;
	private btnConfiguration: HTMLElement;

	private floatingHead: HTMLDivElement;
	private txtChangeState: HTMLDivElement;
	private txtLabelX: HTMLDivElement;
	private txtLabelY: HTMLDivElement;
	private yAxisContainer: HTMLDivElement;
	private yAxisScrollContainer: HTMLDivElement;
	private xAxisContainer: HTMLDivElement;
	private xAxisScrollContainer: HTMLDivElement;
	private gridTableContainer: HTMLDivElement;
	private gridTable: HTMLDivElement;

	private bottomContent: HTMLElement;

	private footerContent: HTMLElement;
	private footerContentWrapper: HTMLElement;
	private sumAxisScrollContainer: HTMLElement;
	private sumAxisContainer: HTMLTableElement;
	private sumTableContainer: HTMLElement;
	private sumTable: HTMLTableElement;

	private _currentSelectionValue: Matrix.SelectionValue = null;

	private __vScrollTimeout: number;

	private _vsState: {
		topSpacer: HTMLTableRowElement;
		bottomSpacer: HTMLTableRowElement;
		rowHeight: number;
		renderedStart: number;
		renderedEnd: number;
	} = null;
	private readonly _VS_BUFFER = 10;
	private readonly _VS_debugCoordinates: boolean = false;

	private _rowPool: Array<{
		rowNode: HTMLTableRowElement;
		colSlots: Array<{ td: HTMLTableCellElement; inner: HTMLDivElement }>;
	}> = [];

	private _mousePressActive: boolean = false;
	private _lastMouseactiveCellEntry: cellEntry = null;

	private readonly: boolean = false;

	private _selectionValues: Array<Matrix.SelectionValue>;
	private _gridContent: Matrix.GridContent<Z>[];
	private _xAxisDescriptors: Matrix.AxisElementDescriptor<X>[];
	private _yAxisDescriptors: Matrix.AxisElementDescriptor<Y>[];
	private _sumLineDescriptors: Record<string, Matrix.SumLineDescriptor>;

	private _columns: Record<number, Matrix.ContentColumn>;
	private _rows: Record<number, Matrix.ContentRow>;
	private _cells: Record<string, Matrix.ContentCell>;
	private _sumRows: Record<number, Matrix.SumRow>;

	
	private _config: Matrix.Config<X, Y, Z>;
	private __dojoStartupDone: boolean = false;

	private _setConfigAttr(config: Matrix.Config) {
		if (this.__dojoStartupDone) {
			this.setup(config);
		} else {
			this._config = config;
		}
	}

	//protected onShow() {
	//	// TODO - im uiframe sollte es eine solche Funktion oder überhaupt das Property gekapselt geben.
	//	if (this.currentDisplayMode == "dlg") {
	//		this._changeStateDisplayNode = this._uiFrameDlg.leftActionContainerNode;
	//	} else {
	//		this._changeStateDisplayNode = DOMhelpers.getGlobalSpaceNode(); 
	//	}
	//}

	setup(config: Matrix.Config<X, Y, Z>) {


		this._config = config;
		if (!config) return;
		if (!this.__dojoStartupDone) return;

		this.reset();

		this._loadConfiguration();

		this.hideNode(this.btnConfiguration, !this._config.enableConfigurationButton);
	}

	
	private _loadConfiguration(): void {

		this.StandbyStart(this.floatingHead);

		let params = {};
		if (typeof (this._config.configurationParams) == "function") {
			params = this._config.configurationParams();
		} else if (typeof (this._config.configurationParams) == "object" && this._config.configurationParams) {
			params = this._config.configurationParams;
		}

		this.RequestManager.callfunction(
			this._config.configurationAPI,
			params,
			lang.hitch(this, this._onLoadConfigurationResponse, true),
			lang.hitch(this, this._onLoadConfigurationResponse, false)
		);
	}

	private _matrixBaseDescriptor: Matrix.MatrixDescriptor<X, Y, Z>;
	private _onLoadConfigurationResponse(success: boolean, response: any) {

		if (success != true) {
			let error = response as more.requestErrorMessage;
			alert(error.Message);
			this.StandbyStop();
		} else {
			let descriptor = response as Matrix.MatrixDescriptor<X, Y, Z>;
			this._matrixBaseDescriptor = descriptor;

			if (descriptor.xElements) {
				this._xAxisDescriptors = descriptor.xElements;
				this._drawXaxisElements();	
			}

			if (descriptor.yElements) {
				this._yAxisDescriptors = descriptor.yElements;
				this._drawYaxisElements();
			}

			if (descriptor.sumLines) {

			}

			if (descriptor.selectionValues) {
				this._setupSelectionValues(descriptor.selectionValues)
			}

			if (descriptor.gridContent) {
				this._gridContent = descriptor.gridContent;
				this._applyGridDataContent();
			}
		}
	}



	private _setupSelectionValues(items: Array<Matrix.SelectionValue>) {
		this._selectionValues = items;

		if (this._selectionValues?.length > 0) {
			for (let entity of this._selectionValues) {
				let colorBG = ColorHelpers.getHexColorFromProperty(entity.coloration, "BG");
				let colorTXT = ColorHelpers.getHexColorFromProperty(entity.coloration, "TXT");
				this.inputSelectionValue.addOption(entity.ID, entity.label, true, colorBG, colorTXT);
			}

			this.inputSelectionValue.startup();

			this.inputSelectionValue.setValue(this._selectionValues[0].ID, true);
			this.hideNode(this.inputSelectionValue, this._selectionValues.length <= 1);
		}
		
		this._refreshCurrentSelectionValue();

		this.hideNode(this.inputSelectionValue, !(this.inputSelectionValue?.entries?.length > 1));
	}


	private _drawXaxisElements(): void {
		//	Zeichnen der Spalten (horizontal)
		//

		this.UiModder.domConstruct.empty(this.xAxisContainer);

		this.UiModder.domConstruct.empty(this.txtLabelX);
		this.hideNode(this.txtLabelX);
		if (this._matrixBaseDescriptor.labelX) {
			this.UiModder.domAttr.set(this.txtLabelX, "innerHTML", this._matrixBaseDescriptor.labelX);
			this.hideNode(this.txtLabelX, false);
		}

		let newColumnsReg: Record<number, Matrix.ContentColumn> = {};

		for (let i = 0; i < this._xAxisDescriptors.length; i++) {

			let descriptor = this._xAxisDescriptors[i];


			let col: Matrix.ContentColumn<X> = {
				ID: descriptor.ID ? descriptor.ID : StringHelpers.numberToString(i, 6),
				x: i,
				cells: {},
				rows: {},
				type: descriptor.type ? descriptor.type : "entity",
				xElement: null
			}

			newColumnsReg[i] = col;

			let xElement: Matrix.Xelement<X> = {
				column: col,
				node: null,
				data: descriptor.data
			};
			col.xElement = xElement;


			let td = this.UiModder.domConstruct.create("td", {
				className: "matrixXcell " + col.type
			}, this.xAxisContainer);

			let headNode = this.UiModder.domConstruct.create("div", {
				className: "matrixXelement " + col.type
			}, td);

			xElement.node = headNode;


			if (col.type == "entity" && this._config.xElementClickCallback) {
				this.UiModder.domClass.toggle(headNode, "clickable hoverAuto", true);
			}
			
			let labelContainer = this.UiModder.domConstruct.create("div", {
				className: "labelContainer"
			}, headNode);

			let labelNode = this.UiModder.domConstruct.create("label", {
				innerHTML: descriptor.label
			}, labelContainer);

			if (this._VS_debugCoordinates) {
				labelNode.innerHTML = col.x + " " + labelNode.innerHTML;
			}

			headNode.setAttribute("data-x", i.toString());
			headNode.setAttribute("data-ID", col.ID);

			let colGroup: Matrix.GroupColumn<X>
			if (descriptor.type == "group") {
				let groupDescriptor = descriptor as Matrix.AxisGroupElementDescriptor<X>;
				colGroup = col as any;

				colGroup.collapsible = groupDescriptor.collapsible === true;
				colGroup.collapsed = groupDescriptor.collapsed == true && groupDescriptor.collapsible === true;

				this.UiModder.domClass.toggle(headNode, "collapsible hoverAuto", colGroup.collapsible);

			} else if (descriptor.type == "entity" && colGroup) {
				headNode.setAttribute("data-xGroupID", colGroup.ID);
				colGroup.children[col.x] = col;
				col.group = colGroup;
			}


			if (descriptor.coloration) ColorHelpers.colorNode(headNode, descriptor.coloration);

			on(headNode, "click", lang.hitch(this, this._onClick_xItem, col));
		}

		this._columns = newColumnsReg;

		let keys = Object.keys(newColumnsReg);
		if (!keys.length) {
			this.UiModder.domAttr.set(this.xAxisContainer, "innerHTML", "!!keine Elemente!!");
		}

		this._continueSetup();
	}



	private _drawYaxisElements(): void {
		//	Zeichnen der Zeilen (vertikal)
		//

		this.UiModder.domConstruct.empty(this.yAxisContainer);


		this.UiModder.domConstruct.empty(this.txtLabelY);
		this.hideNode(this.txtLabelY);
		if (this._matrixBaseDescriptor.labelY) {
			this.UiModder.domAttr.set(this.txtLabelY, "innerHTML", this._matrixBaseDescriptor.labelY);
			this.hideNode(this.txtLabelY, false);
		}

		let newRowsReg: Record<number, Matrix.ContentRow> = {};
		this._rows = {};

		//let paddingLeft = 0;

		let rowAsGroup: Matrix.GroupRow<Y>;
		for (let i = 0; i < this._yAxisDescriptors.length; i++) {

			let descriptor = this._yAxisDescriptors[i];

			let row: Matrix.ContentRow<Y> = {
				cells: {},
				columns: {},
				ID: descriptor.ID ? descriptor.ID : StringHelpers.numberToString(i, 6),
				y: i,
				yElement: null,
				tableRowNode: null,
				type: descriptor.type ? descriptor.type : "entity",
				locked: descriptor.locked === true,
				selectable: descriptor.locked !== false
			};

			newRowsReg[i] = row;

			let yElement: Matrix.Yelement<Y> = {
				row: row,
				node: null,
				data: descriptor.data,
			};
			row.yElement = yElement;


			let rowNode = this.UiModder.domConstruct.create("tr", {
				className: "matrixYrow " + row.type
			}, this.yAxisContainer);
			let td = this.UiModder.domConstruct.create("td", {
				className: "matrixYcell " + row.type
			}, rowNode);
			let headNode = this.UiModder.domConstruct.create("div", {
				className: "matrixYelement " + row.type
			}, td);

			yElement.node = headNode;

			let labelContainer = this.UiModder.domConstruct.create("div", {
				className: "labelContainer"
			}, headNode);

			let labelNode = this.UiModder.domConstruct.create("label", {
				innerHTML: descriptor.label
			}, labelContainer);


			if (this._VS_debugCoordinates) {
				labelNode.innerHTML = row.y + " " + labelNode.innerHTML;
			}

			headNode.setAttribute("data-y", i.toString());
			headNode.setAttribute("data-ID", row.ID);

			if (descriptor.coloration) {
				ColorHelpers.colorNode(td, descriptor.coloration);
			}

			on(headNode, "click", lang.hitch(this, this._onClick_yItem, row));

			if (descriptor.type == "entity" && !!this._config.yElementClickCallback) {

				this.UiModder.domClass.add(row.yElement.node, "clickable hoverAuto");

			}

			if (descriptor.type == "group") {
				rowAsGroup = row as Matrix.GroupRow<Y>;
				let groupDescriptor = descriptor as Matrix.AxisGroupElementDescriptor<Y>;

				rowAsGroup.collapsible = groupDescriptor.collapsible == true;
				rowAsGroup.children = {};
				rowAsGroup.collapsed = groupDescriptor.collapsed === true && groupDescriptor.collapsible === true;

				this.UiModder.domClass.toggle(headNode, "collapsible hoverAuto", rowAsGroup.collapsible);

			} else if (rowAsGroup) {
				// vorher gabs bereits eine Gruppe - d.h. wir sind als Nicht-Gruppeineintrag auch ein Teil dieser Gruppe
				rowAsGroup.children[i] = row;
				row.group = rowAsGroup;
				headNode.setAttribute("data-yGroupID", rowAsGroup.ID);

				
			}
		}

		let keys = Object.keys(newRowsReg);
		if (!keys.length) {
			this.UiModder.domAttr.set(this.yAxisContainer, "innerHTML", "!!keine Elemente!!");
		}

		this._rows = newRowsReg;

		this._continueSetup();
	}

	private _drawSumLines() {
		this.UiModder.domConstruct.empty(this.sumAxisContainer);
		this.UiModder.domConstruct.empty(this.sumTable);

		if (!this._sumLineDescriptors) {
			this.hideNode(this.footerContent);
			return;
		}

		this.hideNode(this.footerContent, false);

		let i = Object.keys(this._rows).length;
		this._sumRows = {};
		for (let sumLineName in this._sumLineDescriptors) {
			let descriptor = this._sumLineDescriptors[sumLineName];

			let sumLine: Matrix.SumRow = {
				type: "sum",
				descriptor: descriptor,
				labelNode: null,
				axisNode: null,
				rowNode: null,
				cells: {},
				y: i,
				yName: descriptor.name,
				invalidated: false
			};


			let axisNode = this.UiModder.domConstruct.create("tr", {
				className: "matrixYrow " + "sum"
			}, this.yAxisContainer);
			let td = this.UiModder.domConstruct.create("td", {
				className: "matrixYcell " + "sum"
			}, axisNode);
			let headNode = this.UiModder.domConstruct.create("div", {
				className: "matrixYelement " + "sum"
			}, td);

			sumLine.axisNode = axisNode;
			

			let labelContainer = this.UiModder.domConstruct.create("div", {
				className: "labelContainer"
			}, headNode);

			let labelNode = this.UiModder.domConstruct.create("label", {
				innerHTML: descriptor.label
			}, labelContainer);

			sumLine.labelNode = labelNode;


			if (this._VS_debugCoordinates) {
				labelNode.innerHTML = sumLine.y + " " + labelNode.innerHTML;
			}

			headNode.setAttribute("data-y", i.toString());
			headNode.setAttribute("data-name", sumLine.yName);

			if (descriptor.coloration) {
				ColorHelpers.colorNode(td, descriptor.coloration);
			}

			this._sumRows[i] = sumLine;
			i++;
		}
	}


	private _updateSumCells(sumLine: Matrix.SumRow, data: Record<string, Matrix.SumContent>, bResetRow?: boolean) {
		if (!sumLine) {
			return;
		}

		if (bResetRow === true || !sumLine.rowNode) {
			if (sumLine.rowNode) {
				this.UiModder.domConstruct.empty(sumLine.rowNode);
				sumLine.cells = {};
			}

			// für alle Spalten neu aufbauen
			for (let x in this._columns) {
				let col = this._columns[x];

				let cell: Matrix.SumCell = {
					contentNode: null,
					outerNode: null,
					wrapperNode: null,
					x: col.x,
					xID: col.ID,
					y: sumLine.y,
					yName: sumLine.yName,
					invalidated: false,
					cellContent: null,
					type: "sum"
				};


				sumLine.cells[x] = cell;
			}
		}


	}

	


	private _drawEmptyGridTable() {
		if (!this._rows || !this._columns) return;

		this.UiModder.domConstruct.empty(this.gridTable);
		this._cells = {};
		this._vsState = null;

		let rowGroup: Matrix.GroupRow;

		for (let y in this._rows) {
			let row = this._rows[y];
			row.tableRowNode = null;// Virtuelles Scrolling: Build data structures only — no DOM for individual cells yet

			//let rowNode = this.UiModder.domConstruct.create("tr", {
			//	"className": "matrixRow " + row.type
			//}, this.gridTable);
			//rowNode.setAttribute("data-y", row.y.toString());
			//rowNode.setAttribute("data-ID", row.ID);

			//row.tableRowNode = rowNode;

			let cellGroupX: Matrix.GroupCell;

			for (let x in this._columns) {
				let col = this._columns[x];
				row.columns[x] = col;
				col.rows[y] = row;

				let xNum = typeof (x) == "string" ? parseFloat(x) : x;
				let yNum = typeof (y) == "string" ? parseFloat(y) : y;
				let xy = this.getXY(xNum, yNum);

				let cell: Matrix.ContentCell = {
					x: xNum,
					y: yNum,
					column: col,
					row: row,
					type: (col.type == "group" || row.type == "group") ? "group" : "entity",
					outerNode: null,
					wrapperNode: null,
					contentNode: null,
					cellContent: null
				};

				if (row.type == "group") {
					rowGroup = row as Matrix.GroupRow;
					let cellGroupY = cell as Matrix.GroupCell<X, Y, Z>;
					cellGroupY.yChildren = {};
				} else if (rowGroup) {
					let cellGroupY = rowGroup.cells[x] as Matrix.GroupCell;
					cell.yParent = cellGroupY;
					cellGroupY.yChildren[xy] = cell;
				}

				if (col.type == "group") {
					cellGroupX = cell as Matrix.GroupCell<X, Y, Z>;
					cellGroupX.xChildren = {};
				} else if (cellGroupX) {
					cell.xParent = cellGroupX;
					cellGroupX.xChildren[xy] = cell;
				}

				row.cells[xNum] = cell;
				col.cells[yNum] = cell;
				this._cells[xy] = cell;

				// fällt durch virtuelles Scrolling erst mal alles weg:
				//	let tdNode = this.UiModder.domConstruct.create("td", {
				//		"className": "matrixCellContainer " + cell.type
				//	}, rowNode);

				//	let innerNode = this.UiModder.domConstruct.create("div", {
				//		"className": "matrixCell " + cell.type
				//	}, tdNode);
				//	cell.node = tdNode as HTMLTableCellElement;
				//	cell.cellNode = innerNode;

				//	innerNode.setAttribute("data-xy", xy);
				//	innerNode.setAttribute("data-x", x);
				//	innerNode.setAttribute("data-y", y);
			}
		}

		let colCount = Object.keys(this._columns).length || 1;
		let spacerStyle = "height:0px;padding:0;border:none;margin:0;";

		let topSpacer = this.UiModder.domConstruct.create("tr", { className: "vs-spacer-top" }, this.gridTable) as HTMLTableRowElement;
		this.UiModder.domConstruct.create("td", { colSpan: colCount, style: spacerStyle }, topSpacer);

		let bottomSpacer = this.UiModder.domConstruct.create("tr", { className: "vs-spacer-bottom" }, this.gridTable) as HTMLTableRowElement;
		this.UiModder.domConstruct.create("td", { colSpan: colCount, style: spacerStyle }, bottomSpacer);

		// auch in y-achse einfügen, damit scrollevents sauber laufen? (0.5px höhe errechnet der browser scheinbar...)
		let ySpacerBottom = bottomSpacer.cloneNode(true);
		let ySpacerTop = topSpacer.cloneNode(true);
		this.UiModder.domConstruct.place(ySpacerTop, this.yAxisContainer, "first");
		this.UiModder.domConstruct.place(ySpacerBottom, this.yAxisContainer, "last");

		this._vsState = {
			topSpacer: topSpacer,
			bottomSpacer: bottomSpacer,
			rowHeight: 0,
			renderedStart: -1,
			renderedEnd: -1
		};

		this._initVirtualScroll();
	}

	private _initVirtualScroll() {
		let rowCount = Object.keys(this._rows).length;
		if (!rowCount) return;

		// Render a small initial batch to measure actual row height
		let initialBatch = Math.min(20, rowCount);
		this._renderRowRange(0, initialBatch - 1, this._vsState.bottomSpacer);
		this._vsState.renderedStart = 0;
		this._vsState.renderedEnd = initialBatch - 1;

		// Force layout to measure row height
		let firstRow = this._rows[0]?.tableRowNode;
		if (firstRow) {
			let measured = firstRow.offsetHeight;
			if (measured > 0) this._vsState.rowHeight = measured;
		}
		if (!this._vsState.rowHeight) this._vsState.rowHeight = 36; // Notfall-Fallback...

		this._updateVirtualScroll();
	}

	/**
	 * Erzeugt die tatsächlich sichtbaren DOM-Elemente
	 * 
	 * @returns
	 */
	private _renderRowRange(startY: number, endY: number, insertBeforeNode: Node | null) {
		if (!this._vsState) return;

		let colKeys = Object.keys(this._columns);

		for (let y = startY; y <= endY; y++) {
			let row = this._rows[y];
			if (!row) continue;
			// skippen falls collapsed:
			if (row.group) {
				if (row.group.collapsed) continue;
			}
			if (row.tableRowNode) {
				insertBeforeNode = row.tableRowNode.nextSibling;
				continue;
			}

			let poolEntry = this._rowPool.length ? this._rowPool.pop() : this._createPoolRow(colKeys);

			let rowNode = poolEntry.rowNode;
			rowNode.className = "matrixRow " + row.type;
			rowNode.setAttribute("data-y", row.y.toString());
			rowNode.setAttribute("data-ID", row.ID);
			row.tableRowNode = rowNode;


			//if (!!this._config.yElementClickCallback && row.type == "entity") {
			//	this.UiModder.domClass.add(row.yElement.node, "clickable hoverAuto");
			//} else {
			//	this.UiModder.domClass.remove(row.yElement.node, "clickable hoverAuto");
			//}		


			this.gridTable.insertBefore(rowNode, insertBeforeNode);
			insertBeforeNode = rowNode.nextSibling || this._vsState.bottomSpacer;

			for (let i = 0; i < colKeys.length; i++) {
				let x = colKeys[i];
				let xNum = parseFloat(x);
				let cell = row.cells[xNum];
				if (!cell) continue;

				let slot = poolEntry.colSlots[i];
				slot.td.className = "matrixCellContainer " + cell.type;
				slot.inner.className = "matrixCell " + cell.type;
				slot.inner.setAttribute("data-xy", this.getXY(xNum, row.y));
				slot.inner.setAttribute("data-x", x);
				slot.inner.setAttribute("data-y", y.toString());

				cell.outerNode = slot.td;
				cell.wrapperNode = slot.inner;
				cell.contentNode = null; // wurde beim Zurücklegen in den Pool geleert

				if (cell.row.group) {
					slot.inner.setAttribute("data-yGroupID", cell.row.group.ID);
				} else {
					slot.inner.setAttribute("data-yGroupID", "");
				}

				if (cell.column.group) {
					slot.inner.setAttribute("data-xGroupID", cell.column.group.ID);
				} else {
					slot.inner.setAttribute("data-xGroupID", "");
				}
				
				

				this.drawCellContent(cell);
			}
		}
	}

	private _createPoolRow(colKeys: string[]): { rowNode: HTMLTableRowElement; colSlots: Array<{ td: HTMLTableCellElement; inner: HTMLDivElement }> } {
		let rowNode = document.createElement("tr");
		let colSlots: Array<{ td: HTMLTableCellElement; inner: HTMLDivElement }> = [];
		for (let x of colKeys) {
			let td = document.createElement("td");
			let inner = document.createElement("div");
			td.appendChild(inner);
			rowNode.appendChild(td);
			colSlots.push({ td, inner });
		}
		return { rowNode, colSlots };
	}

	private _removeRowRange(startY: number, endY: number) {
		let colKeys = Object.keys(this._columns);

		for (let y = startY; y <= endY; y++) {
			let row = this._rows[y];
			if (!row || !row.tableRowNode) continue;

			let colSlots: Array<{ td: HTMLTableCellElement; inner: HTMLDivElement }> = [];

			for (let i = 0; i < colKeys.length; i++) {
				let xNum = parseFloat(colKeys[i]);
				let cell = row.cells[xNum];
				if (!cell) continue;

				let td = cell.outerNode as HTMLTableCellElement;
				let inner = cell.wrapperNode as HTMLDivElement;

				// Content-Node entfernen und Farben zurücksetzen
				if (inner) {
					while (inner.firstChild) inner.removeChild(inner.firstChild);
					DOMhelpers.setElementColor(inner, null, null);
				}

				cell.contentNode = null;
				cell.outerNode = null;
				cell.wrapperNode = null;

				if (td && inner) colSlots.push({ td, inner });
			}

			let rowNode = row.tableRowNode;
			this.gridTable.removeChild(rowNode);
			row.tableRowNode = null;

			this._rowPool.push({ rowNode, colSlots });
		}
	}

	private _updateVirtualScroll() {

		//console.debug(this.id + " _updateVirtualScroll");

		if (!this._vsState || !this._vsState.rowHeight) return;

		let rowCount = Object.keys(this._rows).length;
		if (!rowCount) return;

		let rowHeight = this._vsState.rowHeight;

		if (this.gridTableContainer.scrollTop != this.yAxisScrollContainer.scrollTop) this.gridTableContainer.scrollTop = this.yAxisScrollContainer.scrollTop;

		let scrollTop = this.gridTableContainer.scrollTop;
		let clientHeight = this.gridTableContainer.clientHeight;

		if (!clientHeight) return;

		// aus der Scrollposition lässt sich mit der Zeilenhöhe errechnen, von wo bis wo das Rendering aktiv ist:
		let visibleStartIndex = Math.floor(scrollTop / rowHeight);
		let visibleEndIndex = Math.ceil((scrollTop + clientHeight) / rowHeight);

		let renderStartIndex = Math.max(0, visibleStartIndex - this._VS_BUFFER);
		let renderEndIndex = Math.min(rowCount - 1, visibleEndIndex + this._VS_BUFFER);
		let renderCount = renderEndIndex - renderStartIndex; // diese Anzahl ist sichtbar und muss tatsächlich gerendert werden

		let collapsedCountBeforeRenderStart = 0;
		let collapsedCountAfterRenderStart = 0;
		let collapsedCountAfterRenderEnd = 0;

		//console.debug("target renderindex: " + renderStartIndex + " - " + renderEndIndex, "rowCount: " + rowCount);

		// jetzt gehören aber zugeklappte Gruppen noch rausgerechnet...
		// alles was VOR dem Renderstartindex collapsed war, zählt nicht zur Höhe, d.h. unser Viewport ist effektiv HÖHER (weiter unten)
		let rowGroup: Matrix.GroupRow;
		for (let i = 0; i < rowCount; i++) {
			if (i == rowCount) break; // stoppen, falls durch Hochzählen des Render-Endindex schon das Ende erreicht worden ist

			let row = this._rows[i];
			
			if (row.type == "group") {
				rowGroup = row as Matrix.GroupRow;
				if (rowGroup.collapsed === true) {
					console.debug("collapsed (group: " + i + "): " + (i + 1) + " - " + (i + Object.keys(rowGroup.children).length));
					// falls die Gruppe VOR dem renderStart auftritt müssen wir start und end (den gesamten Viewport) erhöhen
					if (i < renderStartIndex) {
						collapsedCountBeforeRenderStart += Object.keys(rowGroup.children).length;
						renderStartIndex += Object.keys(rowGroup.children).length;
						renderEndIndex += Object.keys(rowGroup.children).length;
					}
					
					else {
						// wenn die Gruppe WÄHREND des zu rendernden Bereichs liegt, muss das Ende verlängert werden
						if (i <= renderEndIndex) {
							// den Renderindex um die Anzahl der kollabierten Kinderleins erhöhen. was eingeklappt ist, wird nach unten hin verlängert
							renderEndIndex += Object.keys(rowGroup.children).length;
						}

						// RenderEndIndex hat sich vorher schon verlängert. mitzählen was innerhalb des Viewports eingeklappt ist:
						if (i <= renderEndIndex) {
							collapsedCountAfterRenderStart += Object.keys(rowGroup.children).length;

						}
						// wenn es dann außerhalb des Viewports liegt, mitzählen damit der Spacer unten dran korrekt berechnet wird:
						else {
							collapsedCountAfterRenderEnd += Object.keys(rowGroup.children).length;
						}


					}
					
				}
			}
		}

		//console.debug("new renderindex after collapses: " + renderStartIndex + " - " + renderEndIndex, "collapsed before viewport: " + collapsedCountBeforeRenderStart, "collapsed in viewport: " + collapsedCountAfterRenderEnd, "collapsed after viewport: " + collapsedCountAfterRenderEnd);

		renderStartIndex = Math.max(0, renderStartIndex);
		renderEndIndex = Math.min(rowCount - 1, renderEndIndex);

		console.debug("final renderindex adjusted: " + renderStartIndex + " - " + renderEndIndex);

		let prevStart = this._vsState.renderedStart;
		let prevEnd = this._vsState.renderedEnd;

		// Remove rows that scrolled out of view
		if (prevStart >= 0) {
			if (renderStartIndex > prevStart) {
				this._removeRowRange(prevStart, renderStartIndex - 1);
			}
			if (renderEndIndex < prevEnd) {
				this._removeRowRange(renderEndIndex + 1, prevEnd);
			}
		}

		// Render new rows at top (insert before current first rendered row)
		if (prevStart < 0 || renderStartIndex < prevStart) {
			let firstRendered = prevStart >= 0 ? this._rows[prevStart]?.tableRowNode : null;
			let refNode: Node = firstRendered || this._vsState.bottomSpacer;
			this._renderRowRange(renderStartIndex, prevStart > 0 ? prevStart - 1 : renderEndIndex, refNode);
		}

		// Render new rows at bottom (insert before bottomSpacer)
		if (prevEnd >= 0 && renderEndIndex > prevEnd) {
			this._renderRowRange(prevEnd + 1, renderEndIndex, this._vsState.bottomSpacer);
		}

		this._vsState.renderedStart = renderStartIndex;
		this._vsState.renderedEnd = renderEndIndex;

		// Update spacer heights to maintain correct scroll range
		let topHeight = (renderStartIndex - collapsedCountBeforeRenderStart) * rowHeight; // oben so viel wie normalerweise sichtbare Zeilen wären, abzüglich was eingeklappt ist
		let bottomHeight = Math.max(0, (rowCount - 1 - (renderEndIndex + collapsedCountAfterRenderEnd))) * rowHeight; //

		/*
		100 Zeilen = 0-99
		sichtbar: 50-80 (=Viewport)
		eingeklappt: 10-20 (vor dem Viewport)
		außerdem: 60-70 (innerhalb des Viewports, aber das wurde schon korrigiert indem RenderEnd nach unten verlängert worden ist)
		und: 85-90 (nach dem Viewport)

		100 zeilen Höhe bis zurück zur letzten sichtbaren Zeile = rowCount - 1 - renderEndIndex = 99 - 80 = 19 Zeilen Höhe für den Space
		dann noch abziehen: eingeklappte 85-90 = 99 - 80 - 

		*/

		if (topHeight % 1 != 0) {
			console.warn("topHeight uneven", topHeight)
		}

		if (bottomHeight % 1 != 0) {
			console.warn("bottomHeight uneven", bottomHeight)
		}

		let topTd = this._vsState.topSpacer.firstChild as HTMLTableCellElement;
		let bottomTd = this._vsState.bottomSpacer.firstChild as HTMLTableCellElement;
		if (topTd) topTd.style.height = topHeight + "px";
		if (bottomTd) bottomTd.style.height = bottomHeight + "px";

		console.debug("height yAxis: " + this.yAxisContainer.clientHeight, "height gridTable: " + this.gridTable.clientHeight, "scrollTop: " + this.yAxisScrollContainer.scrollTop + " / " + this.gridTableContainer.scrollTop);
	}

	private _applyGridDataContent(/*partialData?: Matrix.GridContent<Z>[]*/) {
		let data = this._gridContent;
		debugger;

		//if (partialData) data = partialData;

		for (let gridEntry of data) {
			let xID = gridEntry.xID;
			let yID = gridEntry.yID;

			let cell = this.getCell(xID, yID);

			// gridEntry ist ein neutraler Datensatz, der sagt was bei XY drin ist
			// im grid stehen Zellen, die vielleicht Inhalt haben, vielleicht aber auch nicht

			if (cell) {
				if (gridEntry.type == "entity") {
					let contentCell = cell as Matrix.ContentCell;
					if (typeof (gridEntry.locked) == "boolean") contentCell.locked = gridEntry.locked === true;

					// wenn GridEntry Daten oder value hat, dann diese verwerten
					if (gridEntry.data || gridEntry.valueID) {
						let selectedValue = this.getSelectionValueByID(gridEntry.valueID);

						contentCell.cellContent = {
							data: gridEntry.data,
							//value: selectedValue,
							valueID: selectedValue.ID,
							xID: xID,
							yID: yID,
							//value: gridEntry.valueID
							//label: gridEntry.label,
							//coloration: gridEntry.coloration,
							//ID: gridEntry.valueID,
							//cell: cell
						};
					} else {
						contentCell.cellContent = null;
					}

					this.drawCellContent(cell);
				} else if (cell.type == "sum") {

				}
			}
		}
	}

	private updateCellValue(cell: Matrix.ContentCell, selectionValue: Matrix.SelectionValue, data?: Z) 
	private updateCellValue(cell: Matrix.ContentCell, selectionValueID: string, data?: Z) 
	private updateCellValue(cell: Matrix.ContentCell, newValue, data?) {
		if (!cell) return;

		let valueID: string = null;
		if (typeof (newValue) == "string") {
			let selectionValue = this.getSelectionValueByID(newValue);
			if (selectionValue) valueID = newValue;
		} else if (newValue && typeof (newValue) == "object") {
			let selectionValue = newValue as Matrix.SelectionValue;
			valueID = selectionValue.ID;
		} 

		if (!cell.cellContent) {
			cell.cellContent = {
				xID: cell.column.ID,
				yID: cell.row.ID,
				//cell: cell,
				valueID: null,
				data: null,
				zID: null // ? auch irgendwie mitgeben lassen?
			};
		}
		cell.cellContent.valueID = valueID;
		if( typeof(data) != "undefined" ) cell.cellContent.data = data;

		this.drawCellContent(cell);

		if (cell.xParent) {
			this.drawCellContent(cell.xParent);
		}

		if (cell.yParent) {
			this.drawCellContent(cell.yParent);
		}
	}

	private drawCellContent(cell: Matrix.Cell): void {
		if (!cell) return;
		if (!cell.wrapperNode) return; // row not yet rendered (virtual scroll)

		let cellNode = cell.wrapperNode;

		this.UiModder.domClass.toggle(cellNode, "hasChildContent", false);

		let entityCell = cell as Matrix.ContentCell;
		let sumCell = cell as Matrix.SumCell;

		if (cell.type == "entity") {
			
			this.UiModder.domClass.toggle(cellNode, "locked", entityCell.locked === true);
			this.UiModder.domClass.toggle(cellNode, "selectable", entityCell.selectable !== false && entityCell.locked !== true);

		}
		
		if (cell.contentNode) {
			this.UiModder.domConstruct.destroy(cell.contentNode);
			cell.contentNode = null;
			DOMhelpers.setElementColor(cell.wrapperNode, null, null); // entfärben
		}
		if (this._VS_debugCoordinates === true) {
			cellNode.innerHTML = cell.x + ":" + cell.y;
		}
		//else if (cell.type == "sum") {

		//}
		else if (entityCell.cellContent) {
			let selectedValue = this.getSelectionValueByID(entityCell.cellContent.valueID);

			let cellContentNode = this.UiModder.domConstruct.create("div", {
				"className": "matrixCellContent",
				"innerHTML": selectedValue.code ? selectedValue.code : ""
			}, cellNode);

			cell.contentNode = cellContentNode;

			if (cell.type == "entity") {
				if (selectedValue?.coloration) ColorHelpers.colorNode(cellNode, selectedValue.coloration);

				if (selectedValue?.icon) DOMhelpers.createFontawesomeIcon(selectedValue.icon, false, cellContentNode);
			} else if (cell.type == "group" || cell.type == "sum") {
				// hier gibts üblicherweise Summen oder sonst was ausm Backend
				let groupCell = cell as Matrix.GroupCell<X>;
				if (groupCell.cellContent.label) {
					this.UiModder.domAttr.set(cellContentNode, "innerHTML", groupCell.cellContent.label);
				} 
				if (groupCell.cellContent.coloration) {
					ColorHelpers.colorNode(cellContentNode, groupCell.cellContent.coloration);
				}
			} 
			
		}
		
		// Gruppen zeichnen ihre Inhalte selber, falls es keinen expliziten cellContent gibt
		else if (cell.type == "group") {

			let groupCell = cell as Matrix.GroupCell<X>;
			let countedValues: Record<any, number> = {};
			for (let key in groupCell.yChildren) {
				let childCell = groupCell.yChildren[key];
				if (childCell.cellContent) {
					let childVal = childCell.cellContent.valueID;
					if (typeof (childVal) != "undefined" && childVal != null) {
						if (countedValues[childVal] == undefined) countedValues[childVal] = 0;
						countedValues[childVal] += 1;
					}
				}
			}

			let bHasContent = Object.keys(countedValues).length > 0
			this.UiModder.domClass.toggle(cellNode, "hasChildContent", bHasContent);
			if (bHasContent) {

				let contentNode = this.UiModder.domConstruct.create("div", {
					"className": "matrixCellGroupContent"
				}, cellNode, "only");

				for (let value in countedValues) {
					let selectionVal = this.getSelectionValueByID(value);
					if (selectionVal) {

						let valueNode = this.UiModder.domConstruct.create("div", {
							"className": "groupValueItem",
							"data-value-count": countedValues[value]
						}, contentNode);

						if (selectionVal.coloration) {
							ColorHelpers.colorNode(valueNode, selectionVal.coloration);
						}

						if (selectionVal.icon) {
							DOMhelpers.createFontawesomeIcon(selectionVal.icon, null, valueNode);
						} else if (selectionVal.code) {
							valueNode.innerHTML = selectionVal.code;
						}
					}
				}
			} else {
				this.UiModder.domConstruct.empty(cellNode);
			}
		} else {
			
		}
	}

	

	private _continueSetup(): void {

		// noch kein Content, aber rows  und columns sind ready
		if (!this._gridContent && this._rows && this._columns) {
			this._drawEmptyGridTable();

			let rows = Object.keys(this._rows);
			let cols = Object.keys(this._columns);
			if (rows.length && cols.length) {
				this.loadContent();
			} else {
				this.StandbyStop();
			}
			return;
		}

		// alles vorhanden. dann kann mit dem initialien zeichnen der Daten begonnen werden
		if (this._gridContent && this._xAxisDescriptors && this._yAxisDescriptors) {
			
			this.StandbyStop();

			this._applyGridDataContent()
			this.yAxisContainer.scrollTop = 0;

			this._updateChangeStateLabel();
		}
	}



	private __contentLoadingInProgress: boolean = false;

	private loadContent(): void {

		if (this.__contentLoadingInProgress == true) {
			return;
		}

		this.__contentLoadingInProgress = true;
		let requestData: object = {
			xIDs: this._getXAxisIDs(false),
			yIDs: this._getYAxisIDs(false),
		};

		let params = {};
		if (typeof (this._config.configurationParams) == "function") {
			params = this._config.configurationParams();
		} else if (typeof (this._config.configurationParams) == "object" && this._config.configurationParams) {
			params = this._config.configurationParams;
		}

		if (params) {
			for (let key in params) {
				requestData[key] = params[key];
			}
		}

		this.RequestManager.callfunction(
			this._config.contentAPI, //"Webtool_API_PepMatrix__GetData_ContentCells",
			requestData,
			lang.hitch(this, this._onLoadContentResponse, true),
			lang.hitch(this, this._onLoadContentResponse, false)
		);
	}

	private _onLoadContentResponse(success: boolean, response: any) {
		this.__contentLoadingInProgress = false;

		if (success != true) {
			let error = response as more.requestErrorMessage;
			alert(error.Message);
		} else {
			let data = response as Matrix.GridContentResponse<Z>;

			if (!this._gridContent || data.resetContents === true) {
				this._gridContent = data.gridContent;
			} else {
				let newDatagrid = this._gridContent;

				//rauswerfen was doppelt wäre:
				for (let entry of data.gridContent) {
					newDatagrid = newDatagrid.filter(test => test.xID != entry.xID || test.yID == entry.yID);
				}

				this._gridContent = newDatagrid;
			}

			this._continueSetup();

		}

	}

	private _getXAxisIDs(bIncludeNonEntities: boolean = false): Array<string> {
		let resultList: Array<string> = []

		for (let key in this._columns) {
			let entry = this._columns[key];
			if (entry.type == "entity" || bIncludeNonEntities == true) {
				resultList.push(entry.ID);
			}
		}

		return resultList;
	}

	private _getYAxisIDs(bIncludeNonEntities: boolean = false): Array<string> {
		let resultList: Array<string> = []

		for (let key in this._rows) {
			let entry = this._rows[key];
			if (entry.type == "entity" || bIncludeNonEntities == true) {
				resultList.push(entry.ID);
			}
		}

		return resultList;
	}



	private getSelectionValueByID(ID: string) {
		if (!this._selectionValues) return null;

		for (let entity of this._selectionValues) {
			if (entity.ID == ID) {
				return entity;
			}
		}
		return null;
	}

	
	private reset(): void {
		this.UiModder.domConstruct.empty(this.xAxisContainer);
		this.UiModder.domConstruct.empty(this.yAxisContainer);
		this.UiModder.domConstruct.empty(this.gridTable);
		this._rowPool = [];
		this._columns = null;
		this._rows = null;
		this._cells = null;
		this._selectionValues = [];

		this._updateChangeStateLabel();

		this.entityStore = new EntityStore();
		this.entityStore.keyAttribute = "zID"; // die Zellen-ID (m-zu-n aus DB oder random neu beim Zuweisen) hat diesmal einen anderen Namen
		on(this.entityStore, "change", lang.hitch(this, this._onChange_EntityStore));
	}

	private _dirty: boolean = false;
	private _onChange_EntityStore() {
		this._updateChangeStateLabel();
		this._checkDirty();
	}

	private _checkDirty() {
		if (this._dirty != this.entityStore.isDirty()) {
			this._dirty = this.entityStore.isDirty();
			this.emit("dirty",this._dirty);
		}

		
	}
	private _updateChangeStateLabel() {

		if (!this._changeStateDisplayNode) return;
		this.UiModder.domConstruct.empty(this._changeStateDisplayNode);

		if (!this.entityStore) return;

		let currentDiff = this.entityStore.getDiffData();

		let label = TranslationHelpers.translate("MatrixGrid_Status__ChangesFormatString");
		label = StringHelpers.stringFormat(label, currentDiff.new.length.toString(), currentDiff.deleted.length.toString())
		this.UiModder.domAttr.set(this._changeStateDisplayNode, "innerHTML", label);
	}

	private _onClick_Rollback() {
		if (!this._dirty) return;

		this._onLoadConfigurationResponse(true, this._matrixBaseDescriptor);
	}

	private _onClick_Save() {
		if (!this._dirty) return;

		this.commitChanges();
	}
	private commitChanges(): void {
		if (this.entityStore.isDirty()) {

			this.StandbyStop();

			this.RequestManager.callfunction(
				this._config.saveAPI,
				this.entityStore.getDiffData(),
				lang.hitch(this, this._onCommitChangesResponse, true),
				lang.hitch(this, this._onCommitChangesResponse, false)
			);
		}
	}

	private _onCommitChangesResponse(success: boolean, response) {
		this.StandbyStop();
		if (success == false) {
			let error = response as more.requestErrorMessage;
			alert(error.Message);
		} else {
			this.entityStore.commit();

			let newData = response as Partial<Matrix.MatrixDescriptor>;

			if (newData.xElements || newData.yElements) {
				this._onLoadConfigurationResponse(true, newData);
			}

			if (newData.gridContent) {
				this._onLoadContentResponse(true, newData.gridContent);
			}
		}
	}



	private getXY(x: number, y: number): string {
		return StringHelpers.numberToString(x, 6).replaceAll(".", "") + ":" + StringHelpers.numberToString(y, 6).replaceAll(".", "");
	}

	private getCol(xID: string): Matrix.ContentColumn
	private getCol(x: number): Matrix.ContentColumn
	private getCol(param): Matrix.ContentColumn {
		if (typeof (param) == "string") {
			for (let key in this._columns) {
				let col = this._columns[key];
				if (col.ID == param) return col;
			}
		} else if (typeof (param) == "number") {
			return this._columns[param];
		}

		return this._columns[param];
	}

	private getRow(yID: string): Matrix.Row
	private getRow(y: number): Matrix.Row
	private getRow(param): Matrix.Row {
		if (typeof (param) == "string") {
			for (let key in this._rows) {
				let row = this._rows[key];
				if (row.ID == param) return row;
			}
			for (let key in this._sumRows) {
				let row = this._sumRows[key];
				if (row.yName == param) return row;
			}
		} else if (typeof (param) == "number") {
			let row: Matrix.Row = this._rows[param];
			if (!row) row = this._sumRows[param];

			return row;
		}

		return this._rows[param];
	}

	private getCell(xID: string, yID: string): Matrix.Cell<X, Y, Z>
	private getCell(x: number, y: number): Matrix.Cell<X, Y, Z>
	private getCell(xyCoord: string): Matrix.Cell<X, Y, Z>
	private getCell(param1: string | number, param2?: string | number): Matrix.Cell<X, Y, Z> {
		if (!this._cells) return null;

		let coord: number[] = [];
		if (typeof (param1) == "string" && typeof (param2) == "string") {
			if (param1 && param2) {
				let col = this.getCol(param1);
				let row = this.getRow(param2);
				if (col && row) {
					coord.push(col.x);
					coord.push(row.y);
				}
			} else return null;
		} else if (typeof (param1) == "string") {
			// == xy-Koordinaten als string
			if (!param1) return null;
			let parts = param1.split(":");
			if (parts.length != 2) return null;

			coord.push(parseFloat(parts[0]));
			coord.push(parseFloat(parts[1]));
		} else if (typeof (param1) == "number" && typeof (param2) == "number") {
			coord.push(param1);
			coord.push(param2);
		} else {
			return null;
		}

		if (coord.length != 2) return;

		let x = coord[0];
		let y = coord[1];
		let xy = this.getXY(x, y);
		let cell = this._cells[xy];
		if (cell) return cell;

		// Fallback:
		let row = this._rows[y];
		if (!row) return null;
		cell = row.cells[x];

		return cell;
	}

	private _onChange_SelectionValue(): void {
		this._refreshCurrentSelectionValue();
	}

	private _onClick_Config() {
		if (this._config.enableConfigurationButton === true) {
			this.emit("callConfig", this._config?.configurationParams);
			this.disableNode(this.domNode);
		} else if (this._config.enableConfigurationButton) {
			this._config.enableConfigurationButton(this._config.configurationParams);
			this.disableNode(this.domNode);
		}	

		// ACHTUNG: ausstehende Änderungen !?		
	}

	

	private _refreshCurrentSelectionValue(): void {
		this._currentSelectionValue = this.getSelectionValueByID(this.inputSelectionValue.getValue());
		let hexColorBG = ColorHelpers.getHexColorFromProperty(this._currentSelectionValue?.coloration, "BG");
		let hexColorTXT = ColorHelpers.getHexColorFromProperty(this._currentSelectionValue?.coloration, "TXT");
		if (hexColorBG) this.domNode.style.setProperty("--_mgCurrentSelectionValueBG", hexColorBG);
		else this.domNode.style.removeProperty("--_mgCurrentSelectionValueBG");

		if (hexColorTXT) this.domNode.style.setProperty("--_mgCurrentSelectionValueTXT", hexColorTXT);
		else this.domNode.style.removeProperty("--_mgCurrentSelectionValueTXT");
	}


	private _onClick_xItem(column: Matrix.ContentColumn): void {

		if (column.type == "group") {
			let groupItem = column as any as Matrix.XGroup;

			this.UiModder.domClass.toggle(groupItem.xElement.node, "collapsed", groupItem.collapsed);

			// das ist aber nur die Achse - jetzt müssen auch in der Table die entsprechenden Rows ausgeblendet werden...
			let nodelist = this.domNode.querySelectorAll("[data-xGroupID='" + groupItem.ID + "']");
			let nodes = [];
			for (let i = 0; i < nodelist.length; i++) nodes.push(nodelist.item(i));
			this.UiModder.domClass.toggleMultiple(nodes, "collapsedX", groupItem.collapsed);

		} else if (column.type == "entity") {
			if (this._config.xElementClickCallback) {
				this._config.xElementClickCallback(column.ID, column.xElement.data);
			}
		}

	}
	// click vertial (auf-/zuklappen)
	//
	private _onClick_yItem(row: Matrix.ContentRow) {

		//console.log("iconNode", iconNode);

		if (row.type == "group") {
			let groupItem = row as any as Matrix.GroupRow;

			let groupItems: Array<DataItem> = [];

			if (groupItem.collapsible == true) {

				groupItem.collapsed = groupItem.collapsed == false;

				this.UiModder.domClass.toggle(row.tableRowNode, "collapsed", groupItem.collapsed);
				this.UiModder.domClass.toggle(row.yElement.node, "collapsed", groupItem.collapsed);

				// das ist aber nur die Achse - jetzt müssen auch in der Table die entsprechenden Rows ausgeblendet werden...
				let nodelist = this.domNode.querySelectorAll("[data-yGroupID='" + groupItem.ID + "']");
				let nodes = [];
				for (let i = 0; i < nodelist.length; i++) nodes.push(nodelist.item(i));
				this.UiModder.domClass.toggleMultiple(nodes, "collapsedY", groupItem.collapsed);

				this._updateVirtualScroll();
			}
		}
		else if (row.type == "entity"){
			// evtl Entityview oder so...
			// callback-Action in der Config?
			if (this._config.yElementClickCallback) {
				this._config.xElementClickCallback(row.ID, row.yElement.data);
			}
		}
	}


	private _onClick_Content(evt): void {
		if (this.readonly == true) {
			return;
		}

		//console.log("_onClick_Content", evt, evt.target);
		if (!this.UiModder.domClass.contains(evt.target, "matrixCell")) {
			return; // klick nicht auf eine zelle ausgeführt
		}

		let cellNode = evt.target as HTMLElement;;
		if (!cellNode?.getAttribute) return;
		let xy = cellNode.getAttribute("data-xy");
		if (!xy) return;
		let contentEntry = this.getCell(xy);


		this._handleContentCellSelection(contentEntry as any);
	}


	private _onMouseDown_Content(evt): void {
		this._mousePressActive = true;
	}

	private _onMouseUp_Content(evt): void {
		this._mousePressActive = false;

	}

	private _currentHover: { x: string, y: string, cell: Matrix.Cell } = { x: null, y: null, cell: null };
	private _onMouseMove_Content(evt): void {
		let cellNode = evt.target as HTMLElement;
		let cell: Matrix.Cell;
		let yNode: HTMLElement;
		let xNode: HTMLElement;
		let x: string;
		let y: string;

		if (cellNode?.getAttribute) {
			let xy = cellNode.getAttribute("data-xy");
			x = cellNode.getAttribute("data-x");
			y = cellNode.getAttribute("data-y");

			if (x && y) {
				cell = this.getCell(xy);
			}
		}

		if (this._currentHover.x != x || this._currentHover.y != y) {
			// bestehende Hover-Effekt entfernen:
			let currentHoveredElements = this.domNode.getElementsByClassName("hover");
			if (currentHoveredElements?.length) {
				let items = [];
				for (let index = 0; index < currentHoveredElements.length; index++) {
					items.push(currentHoveredElements.item(index)); // sonst entfernt sich item durch die Manipulation selber aus dem Array!
				}
				this.UiModder.domClass.removeMultiple(items, "hover");
			}

			currentHoveredElements = this.domNode.getElementsByClassName("matrixCell colHover");
			if (currentHoveredElements?.length) {
				let items = [];
				for (let index = 0; index < currentHoveredElements.length; index++) {
					for (let index = 0; index < currentHoveredElements.length; index++) {
						items.push(currentHoveredElements.item(index)); // sonst entfernt sich item durch die Manipulation selber aus dem Array!
					}
				}

				this.UiModder.domClass.removeMultiple(items, "colHover");
			}
		}

		// falls Zelle: 
		if (cell && cell.type == "entity") {
			let contentCell = cell as Matrix.ContentCell;
			if (this._mousePressActive == true) {

				//	Wenn mausklick aktiv und maus über contentcells bewegt wird, dann wird selektion ausgeführt
				//		
			//	if (cell != this._lastMouseactiveCellEntry) {
			//		this._lastMouseactiveCellEntry = cell;

			//		this._handleContentCellSelection(cell);
			//	}
			}

			if (contentCell.locked !== true && contentCell.selectable !== false) {
				this.UiModder.domClass.add(cell.wrapperNode, "hover");
			}

			let verticalAligned = this.domNode.querySelectorAll("[data-x='" + x + "']");
			if (verticalAligned?.length) {
				for (let i = 0; i < verticalAligned.length; i++) {
					let item = verticalAligned.item(i);
					this.UiModder.domClass.add(item, "colHover");
				}
			}
		}

		// X und Y auch markieren:
		if (x && this._currentHover.x != x) {
			// X
			let col = this._columns[parseFloat(x)];
			if (col) {
				this.UiModder.domClass.add(col.xElement.node, "hover");
			}
		}

		if (y && this._currentHover.y != y) {
			// Y
			let row = this._rows[parseFloat(y)];

			if (row) {
				this.UiModder.domClass.add(row.yElement.node, "hover");
			}
		}

		this._currentHover.x = x;
		this._currentHover.y = y;
		this._currentHover.cell = cell;

	}

	setValue(xID: string, yID: string, valueID: string) {
		let cell = this.getCell(xID, yID);
		if (cell) this._setCellValue(cell, valueID);
	}

	getChangedData(): EntityStoreData<Matrix.CellData<Z>> {
		return this.entityStore.getDiffData();
	}
	getData(): Array<Matrix.CellData<Z>> {
		return this.entityStore.getCurrentCompleteList();
	}

	private _setCellValue(anycell: Matrix.Cell, newValue) {
		let targetValue: string;

		if (!anycell) return;

		let cell = anycell as Matrix.ContentCell;
		if (cell.type != "entity") return;		


		if (!newValue) targetValue = null;
		else if (typeof (newValue) == "string") {
			let selectValue = this.getSelectionValueByID(newValue);
			if (selectValue) targetValue = newValue;
			else return;
		} else if (newValue && typeof (newValue) == "object") {
			let selectValue = newValue as Matrix.SelectionValue;
			if (selectValue.ID) {
				targetValue = selectValue.ID;
			}
		}


		if (targetValue) {
			if (this._matrixBaseDescriptor.disableMultiselectionX === true) {
				// andere Zellwerte dieser Achse entfernen
				for (let key in cell.row.cells) {
					let otherCell = cell.row.cells[key];
					if (otherCell.cellContent?.valueID) {
						if (otherCell.locked !== true) {
							this._setCellValue(otherCell, null);
						}
					}
				}
			}

			if (this._matrixBaseDescriptor.disableMultiselectionY === true) {
				// todo
			}
		}

		// zuerst mal auf jeden Fall entfernen
		if (cell.cellContent) {
			let ID = cell.cellContent.zID;
			this.entityStore.deleteEntry(cell.cellContent);

			cell.cellContent = null;
		}


		if (targetValue) {

			cell.cellContent = {
				zID: null,
				//cell: cell,
				xID: cell.column.ID,
				yID: cell.row.ID,
				data: null,
				valueID: targetValue
			};

			let ID = this.entityStore.addEntry(cell.cellContent, "new");
			cell.cellContent.zID = ID;
		} 

		this.drawCellContent(cell);

		if (cell.xParent) {
			this.drawCellContent(cell.xParent);
		}

		if (cell.yParent) {
			this.drawCellContent(cell.yParent);
		}
	}

	private _handleContentCellSelection(cell: Matrix.ContentCell): void {
		if (!cell) return;
		if (cell.type != "entity") return;
		if (cell.locked === true) return;
		if (cell.selectable === false) return;

		let entity = cell.cellContent?.data;

		let itemY = cell.row?.yElement?.data;
		let itemX = cell.column?.xElement?.data;

		let result = true;
		if (this._config.cellClickCheck) {
			result = this._config.cellClickCheck(itemX, itemY, entity);
		}

		if (!result) return;

		if (!cell.cellContent) {
			//	es gibt noch kein Entity auf der Zelle die geklickt wurde. daher erzeugen
			//

			if (!this._currentSelectionValue) return;

			this._setCellValue(cell, this._currentSelectionValue.ID);

		} else {
			//	schon Zelldaten enthalten - entfernen, falls Modus es erlaubt
			//
			if (this._matrixBaseDescriptor.disableEmptySelectionToggle === true) {
				if (!this._currentSelectionValue) {
					return;
				} else {
					this._setCellValue(cell, this._currentSelectionValue.ID);
				}
			} else {
				this._setCellValue(cell, null);
			}
		}
	}

	private _onScroll_XAxis(evt: MouseEvent) {
		let target = evt.target as HTMLElement;
		let left = target.scrollLeft;
		this._syncScrollX(left);
	}
	private _bLockYAxisScrollEvent: boolean = false;
	private _bLockYAxisScrollEventTimeout;
	private _yAxisScrollTimeout: number;
	private _onScroll_YAxis(evt: MouseEvent) {

		if (this._bLockYAxisScrollEvent == true) return;

		let target = evt.target as HTMLElement;
		let top = target.scrollTop;

		this._bLockContentScrollEvent = true;

		this._syncScrollY(top, evt);

		if (this._bLockContentScrollEventTimeout) clearTimeout(this._bLockContentScrollEventTimeout);
		this._bLockContentScrollEventTimeout = setTimeout(lang.hitch(this, function () { this._bLockContentScrollEvent = false; }), 15);
	}
	private _bLockContentScrollEvent: boolean = false;
	private _bLockContentScrollEventTimeout;
	private _yScrollTimeout: number;
	private _onScroll_Content(evt: MouseEvent) {

		if (this._bLockContentScrollEvent == true) return;

		let target = evt.target as HTMLElement;
		let top = target.scrollTop;

		this._bLockYAxisScrollEvent = true
		this._syncScrollY(top, evt);

		let left = target.scrollLeft;
		this._syncScrollX(left);

		if (this._bLockYAxisScrollEventTimeout) clearTimeout(this._bLockYAxisScrollEventTimeout);
		this._bLockYAxisScrollEventTimeout = setTimeout(lang.hitch(this, function () { this._bLockYAxisScrollEvent = false; }), 15);

	}

	private _syncScrollY(newTop: number, evt) {
		//let target = evt.target as HTMLElement;
		//let left = target.scrollLeft;
		let top = newTop;//target.scrollTop;

		//this.UiModder.domClass.add(this.bottomContent, "scrolling");
		let source = evt.target as HTMLElement;
		//console.log(this.id + "_updateScrollFromContent", "newTop: ", newTop, "delta y: ", top - this.yAxisScrollContainer.scrollTop, "source: " + source.getAttribute("data-dojo-attach-point"), evt);

		if (typeof (top) == "number") // halbe Pixel gehn nicht
		{
			if (top < 0) {
				top = Math.ceil(top); // sonst ist raufscrollen stotterig (stuttery)
			} else {
				top = Math.floor(top); 
			}
			
		}
		

		// je nach Lock ist eins davon der Auslöser und das andere gehört geupdatet:
		this.yAxisScrollContainer.scrollTop = top; // sollte eigentlich immer synchron sein solange das Dingt nicht unten irgendwo begrenzt wird
		this.gridTableContainer.scrollTop = top;


		if (this.__vScrollTimeout) clearTimeout(this.__vScrollTimeout);
		this.__vScrollTimeout = setTimeout(lang.hitch(this, this._updateVirtualScroll), 50);
	}

	private _syncScrollX(newLeft: number) {
		let left = newLeft

		//this.UiModder.domClass.add(this.bottomContent, "scrolling");
		if (typeof (left) == "number" && left % 1 != 0) // halbe Pixel gehn nicht
		{
			left = Math.ceil(left);
		}

		this.xAxisScrollContainer.scrollLeft = left;
		this.gridTableContainer.scrollLeft = left;

		// nur wenn Summenbereich aktiv

		this.sumTableContainer.scrollLeft = left;
	}

	private _onScroll_SumContent(evt: MouseEvent) {
		let target = evt.target as HTMLElement;
		let left = target.scrollLeft;
		this._syncScrollX(left);

	}
	private _onScroll_SumAxis(evt: MouseEvent) {
		let target = evt.target as HTMLElement;
		let top = target.scrollTop;

		// muss ja nix syncen oder? hier scrollen wir nur vertikal, Achse und Content sind einfach normal gekoppelt
	}

	postCreate(): void {
		super.postCreate.apply(this, arguments as any);
		///

		this.RequestManager.handleAs = "json";
	}


	

	startup(): void {
		super.startup.apply(this, arguments as any);

		this._changeStateDisplayNode = this.txtChangeState;

		let footer = document.getElementById("mainFooter");
		let computedStyle = window.getComputedStyle(footer);

		let heightStr = computedStyle.height;
		let marginStr = computedStyle.marginTop;

		let footerHeight = parseInt(heightStr.replace('px', ''));
		let footerMargin = parseInt(marginStr.replace('px', ''));

		if (footer) {
			let height = footerHeight + footerMargin;
			let main = this.domNode;// document.getElementById("matrixMain");
			main.style.setProperty("--footerHeight", height + "px");
		}



		this.__dojoStartupDone = true;
	}
}

export default mdsWidget(MatrixGrid);